// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../../Date";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { WireType, } from "../../../../runtime/wire/index";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        name: "",
        schoolName: "",
        schoolStudentNumber: "",
        schoolDepartment: "",
        gender: "",
        mobilePhoneNumber: "",
        phoneNumber: "",
        birthData: undefined,
        studentType: "",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.name !== undefined)
        result.name = tsValueToJsonValueFns.string(value.name);
    if (value.schoolName !== undefined)
        result.schoolName = tsValueToJsonValueFns.string(value.schoolName);
    if (value.schoolStudentNumber !== undefined)
        result.schoolStudentNumber = tsValueToJsonValueFns.string(value.schoolStudentNumber);
    if (value.schoolDepartment !== undefined)
        result.schoolDepartment = tsValueToJsonValueFns.string(value.schoolDepartment);
    if (value.gender !== undefined)
        result.gender = tsValueToJsonValueFns.string(value.gender);
    if (value.mobilePhoneNumber !== undefined)
        result.mobilePhoneNumber = tsValueToJsonValueFns.string(value.mobilePhoneNumber);
    if (value.phoneNumber !== undefined)
        result.phoneNumber = tsValueToJsonValueFns.string(value.phoneNumber);
    if (value.birthData !== undefined)
        result.birthData = encodeJson_1(value.birthData);
    if (value.studentType !== undefined)
        result.studentType = tsValueToJsonValueFns.string(value.studentType);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.name !== undefined)
        result.name = jsonValueToTsValueFns.string(value.name);
    if (value.schoolName !== undefined)
        result.schoolName = jsonValueToTsValueFns.string(value.schoolName);
    if (value.schoolStudentNumber !== undefined)
        result.schoolStudentNumber = jsonValueToTsValueFns.string(value.schoolStudentNumber);
    if (value.schoolDepartment !== undefined)
        result.schoolDepartment = jsonValueToTsValueFns.string(value.schoolDepartment);
    if (value.gender !== undefined)
        result.gender = jsonValueToTsValueFns.string(value.gender);
    if (value.mobilePhoneNumber !== undefined)
        result.mobilePhoneNumber = jsonValueToTsValueFns.string(value.mobilePhoneNumber);
    if (value.phoneNumber !== undefined)
        result.phoneNumber = jsonValueToTsValueFns.string(value.phoneNumber);
    if (value.birthData !== undefined)
        result.birthData = decodeJson_1(value.birthData);
    if (value.studentType !== undefined)
        result.studentType = jsonValueToTsValueFns.string(value.studentType);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.name !== undefined) {
        const tsValue = value.name;
        result.push([1, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.schoolName !== undefined) {
        const tsValue = value.schoolName;
        result.push([2, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.schoolStudentNumber !== undefined) {
        const tsValue = value.schoolStudentNumber;
        result.push([3, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.schoolDepartment !== undefined) {
        const tsValue = value.schoolDepartment;
        result.push([4, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.gender !== undefined) {
        const tsValue = value.gender;
        result.push([5, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.mobilePhoneNumber !== undefined) {
        const tsValue = value.mobilePhoneNumber;
        result.push([6, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.phoneNumber !== undefined) {
        const tsValue = value.phoneNumber;
        result.push([7, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.birthData !== undefined) {
        const tsValue = value.birthData;
        result.push([8, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.studentType !== undefined) {
        const tsValue = value.studentType;
        result.push([9, tsValueToWireValueFns.string(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.name = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.schoolName = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.schoolStudentNumber = value;
    }
    field: {
        const wireValue = wireFields.get(4);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.schoolDepartment = value;
    }
    field: {
        const wireValue = wireFields.get(5);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.gender = value;
    }
    field: {
        const wireValue = wireFields.get(6);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.mobilePhoneNumber = value;
    }
    field: {
        const wireValue = wireFields.get(7);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.phoneNumber = value;
    }
    field: {
        const wireValue = wireFields.get(8);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.birthData = value;
    }
    field: {
        const wireValue = wireFields.get(9);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.studentType = value;
    }
    return result;
}
